/*
A couple of assumptions (which we can tweak later):

Back goes to the active waiver (or wherever you choose later).
Discard Draft and Review & Publish simply call callback functions supplied by the layout.
The title, location name and address come from the waiver object.
The publish button text changes automatically for a new version.

Instead of putting navigation logic inside the component, I made it callback-based:

<WaiverHeader
    waiver={waiver}
    onDiscard={handleDiscard}
    onPublish={handlePublish}
    publishing={publishing}
/>

Later, WaiverEditorLayout will own:
const handleDiscard = () => {
    ...
}

const handlePublish = () => {
    ...
}

*/
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const WaiverHeader = ({
    waiver,
    onDiscard,
    onPublish,
    publishing = false,
}) => {

    const navigate = useNavigate();

    const isNewVersion = waiver?.waiverStatus === "new_version";
    const isDraft = waiver?.waiverStatus === "draft";

    const showDiscardButton = isNewVersion || isDraft;

    // Adjust these to match your actual data structure
    const location = waiver?.primaryLocation || waiver?.locations?.[0];

    const locationName = location?.name || "";
    const address = [
        location?.addressLine1,
        location?.city,
        location?.state,
        location?.zipCode,
    ]
        .filter(Boolean)
        .join(", ");

    return (

        <div className="mb-8">

            {/* Top Row */}

            <div className="flex items-start justify-between">

                <div>
                    
                    <button
                        onClick={() => {
                            /*if (isNewVersion) {
                                //navigate(`/business/waiverviewer/${waiver.versionOfWaiverId}`);
                                navigate(`/business/waiverbuilder/smart/${waiver.versionOfWaiverId}/step-7`);
                            } else {
                                navigate("/business/waivers");
                            }*/

                            navigate("/business/waivers");
                        }}
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-black mb-6"
                    >
                        <ArrowLeft size={16} />

                        <span>
                            {/*isNewVersion
                                ? `Back to Active v${waiver?.parentVersionNumber ?? ""}`
                                : "Back"*/}
                            Back    
                        </span>
                    </button>

                    <h1 className="text-3xl font-semibold mb-6">

                        {waiver?.waiverName}

                    </h1>

                    <div className="text-sm text-gray-700 leading-6">

                        <div>{locationName}</div>

                        <div>{address}</div>

                    </div>

                </div>

                <div className="flex flex-col items-end">
                    <div className="flex items-center gap-4">

                        {showDiscardButton && (
                            <button
                                onClick={onDiscard}
                                className="text-sm underline text-gray-600 hover:text-black"
                            >
                                Discard Draft
                            </button>
                        )}

                        <button
                            onClick={onPublish}
                            disabled={publishing}
                            className={`rounded-full px-7 py-3 font-medium transition ${
                                publishing
                                    ? "bg-yellow-200 cursor-not-allowed"
                                    : "bg-yellow-400 hover:bg-yellow-500"
                            }`}
                        >
                            {publishing
                                ? "Publishing..."
                                : isNewVersion
                                    ? "Review & Publish New Version"
                                    : "Review & Publish"}
                        </button>

                    </div>

                    <p className="mt-2 text-sm text-gray-500">
                        Auto-saved draft · Not live
                    </p>
                </div>

            </div>

        </div>

    );

};

export default WaiverHeader;